import { useMutation } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WarehouseMapApiAdapter, type PickingRouteRequest } from '../adapters/WarehouseMapApiAdapter';
import type { RouteResult } from '../models/types';

export const usePickingRoute = (warehouseId: number) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new WarehouseMapApiAdapter(httpClient);

  return useMutation<RouteResult, Error, PickingRouteRequest>({
    mutationFn: (request) => adapter.computePickingRoute(warehouseId, request),
  });
};
